<template>
  <div data-app>
    <v-card>
      <v-card-title>
        {{ cardTitle }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="equipmentCollection"
        :search="search"
        @click:row="handleClickItem"
        :loading="loadingTable"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <EquipmentModalForm
              :modalData="modalData"
              :permissions="permissions"
              :statuses="statuses"
              :employeeCollection="employeeCollection"
              @closeModalForm="handleCloseModalForm"
              @saveModalForm="handleSaveModalForm"
              @new="handleNew"
            ></EquipmentModalForm>
            <v-spacer></v-spacer>
            <DeleteModalDialog
              :dialogDelete="dialogDelete"
              @closeDelete="handleCloseDelete"
              @deleteItemConfirm="handleDeleteItemConfirm"
            >
            </DeleteModalDialog>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.user.name }}
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="statuses.system">{{
            statuses.companySettings.department[item.status].value
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            v-if="permissionCan('delete') && item.deletable"
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import EquipmentModalForm, { initialFormData } from "./EquipmentModalForm";

import DeleteModalDialog from "@/view/components/DeleteModalDialog";

import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";

export const ENDPOINT = "maintenance/equipment/";

export const PERMISSION_TO = "maintenance.equipment.";

export default {
  name: "Equipments",
  components: { EquipmentModalForm, DeleteModalDialog },
  mixins: [listModelsMixins],
  data() {
    return {
      routeName: "equipments",
      routePath: "/maintenance/equipments/",
      permissionTo: PERMISSION_TO,

      cardTitle: "Equipments",
      search: "",
      permissions: JSON.parse(localStorage.permissions),
      headers: [
        {
          text: "Equipment",
          value: "equipment_name",
        },
        {
          text: "Equipment number",
          value: "equipment_number",
        },
        {
          text: "Owner",
          value: "name",
        },
        {
          text: "Maintenance period (month)",
          value: "frequency",
        },
        {
          text: "Next maintenance",
          value: "next_maintenance",
        },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      modalData: {
        dialog: false,
        editedId: null,
      },

      editedItem: Object.assign({}, initialFormData()),

      dialogDelete: false,
      loadingTable: true,
      endPoint: ENDPOINT,
    };
  },

  computed: {
    ...mapGetters(["equipmentCollection", "statuses", "employeeCollection"]),
  },

  watch: {
    dialogDelete(val) {
      val || this.handleCloseDelete();
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.$nextTick(() => {
            this.editItem(id);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["fetchEquipment", "fetchEmployee"]),
    fetchModel() {
      this.fetchEmployee();
      return this.fetchEquipment();
    },
  },

  mounted() {
    this.fetchModel().then(() => (this.loadingTable = false));
  },
};
</script>
